var map = {
	"./custom.png": 67,
	"./fasting.png": 65,
	"./gain_weight.png": 62,
	"./healthy.png": 61,
	"./keto.png": 59,
	"./medical.png": 64,
	"./nutritient.png": 66,
	"./vegan.png": 60,
	"./wedding.png": 63
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;